const tags_es = require('./tags.json')
export default tags_es